import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import axios from "axios";
import update from "immutability-helper";

// Compoenents
import DiscountCodeSelector from './DiscountCodeSelector'

// State
import { addCouponToCart, addDiscountToCart } from '../../../store/actions/cart'
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../shared/vars";

class SaleCodesForm extends Component {
    constructor(props){
        super(props)
        this.state = {
            code: '',
            showSelectMessage: false,
            showSelectorDialog: false,
            discountCodes: [],
            discountCode: {}
        }
    }

    componentWillReceiveProps(nextProps){
        // Reset code to blank when successfully submitted
        if(this.props.success === '' && nextProps.success !== this.props.success){
            this.setState({ code: '' })
        }
    }

    componentDidMount(){
        this.loadDiscountCodes();
    }

    //Loads available discount codes (not sales codes)
    loadDiscountCodes(){
        this.setState(
			{},
			() => {
                const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY }

                return axios.get(REACT_APP_API_URL + 'discount-multiple/', { headers: AUTH_HEADER })
                .then((response) => {
                    this.setState({
                        ...this.state,
                        discountCodes: response.data.discount_codes
                    })
                })
                .catch((err) => {
                    console.log(err);
                })
			}
		);
    }

    handleInputChange(event){
		this.setState({
			[event.target.id]: event.target.value
		})
    }

    handleKeyPress(event){
		if(event.key === 'Enter'){
			this.handleSubmit(event)
		}
    }

    handleOpenSelector = (discountCode) => {
        this.setState({
            ...this.state,
            showSelectorDialog: true,
            discountCode: update(this.state.discountCode, { $set: discountCode})
        })
    }

    handleCloseSelector = () => {
        this.setState({
            ...this.state,
            showSelectorDialog: false
        })
    } 
    // handleSubmit(event){
    //     event.preventDefault()
    //     if(!this.props.codes.length){
    //         this.setState({showCountError: false});
    //         this.props.addCouponToCart(this.state.code);
    //     } else {
    //         this.setState({showCountError: true});
    //     }
    // }
    handleSubmit(event){
        event.preventDefault()
        const {discountCodes, code} = this.state;
        const {customer} = this.props;
        // If entered code is a discount code, open the selector
        // Else just apply the coupon code
        if(!discountCodes.length){
            this.props.addCouponToCart(this.state.code);
        } else {
            for(var i = 0; i < discountCodes.length; i++){
                if(discountCodes[i].code.toLowerCase() === code.toLowerCase()){
                    this.props.addDiscountToCart(this.state.code, !!customer ? customer.user.top_tier : "");
                    break;
                } 
                else if ((i + 1) === discountCodes.length){
                    this.props.addCouponToCart(this.state.code);
                    break;
                }
            } 
        }
    }

    render() {
        const { error, success, loading } = this.props;

        return (
            <Fragment>
                <hr className="base-divider"/>
                <h2 className="review-form-titles">Coupon Code:</h2>
                {!!error && Object.keys(error).map(errorKey => {
                    return <div className="error top-margin" key={errorKey}>{error[errorKey]}</div>
                })}

                {success &&
                    <div className="success top-margin">{success}</div>
                }

                <div className="floated-field-container">
                    <div className="form-field half-field">
                        <input type="text" id="code" placeholder="Enter code"
                            value={this.state.code}
                            onKeyPress={e => this.handleKeyPress(e)}
                            onChange={e => this.handleInputChange(e)}
                        />
                    </div>
                    <div className="form-field half-field">
                        <button className={"btn btn--floated-right" + (loading ? ' loading' : '')} disabled={loading} onClick={e => this.handleSubmit(e)}><span>Apply Coupon</span></button>
                    </div>
                    {this.state.showSelectorDialog && 
                    <DiscountCodeSelector 
                        codes={this.state.codes} 
                        discountCode={this.state.discountCode}
                        handleCloseSelector={this.handleCloseSelector}
                        handleApplyCoupon={this.handleApplyCoupon}
                    />}
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        codes: state.cart.codes,
        customer: state.user.customer,
        error: state.cart.couponError,
        success: state.cart.couponSuccess,
        loading: state.cart.couponInProcess
    }
}

export default connect(mapStateToProps, { addCouponToCart, addDiscountToCart })(SaleCodesForm)



// WEBPACK FOOTER //
// ./src/components/checkout/order-review/SaleCodesForm.js